import { ElementRef } from '@angular/core';
/**
 * @file Directive to add or remove the required attribute from a html element.
 * @author Win Haanstra.
 */
/**
 * DESCRIBE-THE-CLASS
 */
var ToggleRequiredDirective = /** @class */ (function () {
    /**
     * Constructs a ToggleRequiredDirective
     */
    function ToggleRequiredDirective(element) {
        this.element = element;
    }
    Object.defineProperty(ToggleRequiredDirective.prototype, "symToggleRequired", {
        /**
         * DESCRIBE-THE-FUNCTIONALITY-OF-THE-FUNCTION
         * @param PARAM-NAME DESCRIBE-THE-PARAM
         * @param PARAM-NAME DESCRIBE-THE-PARAM
         * @returns DESCRIBE-THE-RETURN
         */
        set: function (condition) {
            if (condition) {
                this.element.nativeElement.setAttribute('required', 'true');
            }
            else {
                this.element.nativeElement.removeAttribute('required');
            }
        },
        enumerable: true,
        configurable: true
    });
    return ToggleRequiredDirective;
}());
export { ToggleRequiredDirective };
